import { IonImg, IonItem, IonText, useIonViewDidEnter } from '@ionic/react';
import classNames from 'classnames';
import { Business } from 'model';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useSearchBusinessByPendingApprovalsQuery } from '../../api/BusinessApi';
import GenericBusinessIcon from '../../assets/buildingIcon.png';
import { Header } from '../../components/Header';
import { IconButton } from '../../components/IconButton';
import { NoResults } from '../../components/NoResults';
import { IconArrowBack, IconBusiness, IconCheckCircle, IconUpload } from '../../components/QuirkIcons';
import { QuirkIonContent } from '../../components/QuirkIonContent';
import { QuirkIonPage } from '../../components/QuirkIonPage';
import { QuirkLoader } from '../../components/QuirkLoader';
import { getBusinessImages } from '../../util/getBusinessImages';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './AdminBusinessApprovals.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import itemStyles from '../../components/BusinessItem.module.css';

const BusinessClaimItem: React.FC<{ business: Business }> = ({ business }) => {
	const [imageError, setImageError] = useState(false);
	const { logo } = getBusinessImages(business);
	const history = useHistory();
	const isSubmission = business.submissionStatus === 'pending';
	const isClaim = business.claimStatus === 'pending';
	return (
		<IonItem
			className={classNames(itemStyles.IonItem, 'pointer', styles.claimItem)}
			onClick={() => {
				history.push(`/main/settings/admin/business/approval/${business._id}`);
			}}
		>
			<div className={styles.itemIcon}>
				<IonImg
					className={itemStyles.businessImage}
					onIonError={() => setImageError(true)}
					src={imageError ? GenericBusinessIcon : logo}
				/>
			</div>
			<div className={styles.itemText}>
				<IonText className={itemStyles.businessName}>{business?.name}</IonText>
				<IonText className={itemStyles.description}>{business?.description}</IonText>
			</div>
			<div className={styles.actionIcon}>
				{isClaim && (
					<div className={styles.typeWrapper}>
						<IconCheckCircle size="medium" />
						<span>claimed</span>
					</div>
				)}
				{isSubmission && (
					<div className={styles.typeWrapper}>
						<IconUpload size="medium" />
						<span>suggested</span>
					</div>
				)}
			</div>
		</IonItem>
	);
};

export function AdminBusinessApprovals() {
	const { data, isError, isLoading, refetch } = useSearchBusinessByPendingApprovalsQuery(undefined);
	const history = useHistory();
	useIonViewDidEnter(() => {
		if (!isLoading) {
			refetch();
		}
	});
	const businesses = !isError && !isLoading ? data ?? [] : [];
	return (
		<QuirkIonPage name="Manage Business Approvals">
			<Header
				title="Manage Business Approvals"
				left={
					<IconButton
						icon={<IconArrowBack />}
						onClick={() => {
							history.go(-1);
						}}
					/>
				}
			/>
			<QuirkIonContent scroll={false}>
				<>
					<QuirkLoader
						isLoading={isLoading}
						loadingMessage="Loading pending approvals..."
						data={businesses}
						noResults={
							<NoResults
								heading="No pending approvals."
								subheading="There are no pending approvals at this time."
								icon={<IconBusiness />}
							/>
						}
					>
						<>
							{businesses?.map((business: Business) => (
								<BusinessClaimItem business={business} key={business._id} />
							))}
						</>
					</QuirkLoader>
				</>
			</QuirkIonContent>
		</QuirkIonPage>
	);
}
